import $ from 'jquery';
import Announcement from '@shopify/marketing-assets/dist/javascripts/modules/announcement';
import analytics from '@shopify/marketing-assets/dist/javascripts/global/analytics';
import {track as trackFacebookPixel} from '../utilities/facebook-pixel';

class NotificationManager {
  successEvent = 'PushSubscribe';

  constructor() {
    window._aimtellReady = () => this.handleReady();
    window._aimtellPermissionGranted = () => this.handlePermissionGranted();
  }

  prompt() {
    return window._aimtellPrompt();
  }

  eligible() {
    return window._aimtellSupportsPush() && window._aimtellCheckPermissions() === 'default';
  }

  initializeAnnouncement() {
    const $announcement = $('[data-announcement-id=notification_announcement]');

    this.announcement = new Announcement($announcement);

    $announcement.on('click', '.announcement__link', (evt) => {
      evt.preventDefault();
      this.prompt();
    });
  }

  handleReady() {
    if (this.eligible()) {
      this.initializeAnnouncement();
    }
  }

  handlePermissionGranted() {
    trackFacebookPixel(this.successEvent);
    analytics.track(this.successEvent);

    if (this.announcement) {
      this.announcement.close();
    }
  }
}

export default NotificationManager;
